export default __webpack_public_path__ + "static/media/xmasbag.dab1357c.svg";